import { type Optional } from '@direct-frontend/stdlib';
import { OrderDeliveryServices, type ServiceType } from '@/shared/api/order';
import pinCdekSelectedSource from '../assets/pinCdekSelected.svg';
import pinCdekUnselectedSource from '../assets/pinCdekUnselected.svg';
import pinDalliSelectedSource from '../assets/pinDalliSelected.svg';
import pinDalliUnselectedSource from '../assets/pinDalliUnselected.svg';
import pinMarketFboSelectedSource from '../assets/pinMarketFboSelected.svg';
import pinMarketFboUnselectedSource from '../assets/pinMarketFboUnselected.svg';
import pinMarketSelectedSource from '../assets/pinMarketSelected.svg';
import pinMarketUnselectedSource from '../assets/pinMarketUnselected.svg';
import pinOzonSelectedSource from '../assets/pinOzonSelected.svg';
import pinOzonUnselectedSource from '../assets/pinOzonUnselected.svg';
import pinPecSelectedSource from '../assets/pinPecSelected.svg';
import pinPecUnselectedSource from '../assets/pinPecUnselected.svg';
import pinRussianPostSelectedSource from '../assets/pinRussianPostSelected.svg';
import pinRussianPostUnselectedSource from '../assets/pinRussianPostUnselected.svg';
import pinSelfSelectedSource from '../assets/pinSelfSelected.svg';
import pinSelfUnselectedSource from '../assets/pinSelfUnselected.svg';

const MAP_SERVICE_ICONS = new Map<ServiceType, { selected: string; unselected: string }>([
    [
        OrderDeliveryServices.CDEK,
        {
            selected: pinCdekSelectedSource,
            unselected: pinCdekUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.YANDEX_DELIVERY,
        {
            selected: pinMarketSelectedSource,
            unselected: pinMarketUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.META_SHIP_RUSSIAN_POST,
        {
            selected: pinRussianPostSelectedSource,
            unselected: pinRussianPostUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.META_SHIP_DALLI,
        {
            selected: pinDalliSelectedSource,
            unselected: pinDalliUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.YANDEX_MARKET_FBO,
        {
            selected: pinMarketFboSelectedSource,
            unselected: pinMarketFboUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.META_SHIP_PECOM,
        {
            selected: pinPecSelectedSource,
            unselected: pinPecUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.SELF,
        {
            selected: pinSelfSelectedSource,
            unselected: pinSelfUnselectedSource,
        },
    ],
    [
        OrderDeliveryServices.OZON,
        {
            selected: pinOzonSelectedSource,
            unselected: pinOzonUnselectedSource,
        },
    ],
]);

export const getPinSrc = (serviceType: ServiceType, isSelected: boolean): Optional<string> =>
    MAP_SERVICE_ICONS.get(serviceType)?.[isSelected ? 'selected' : 'unselected'];
